import React from 'react'
import Chip from '@material-ui/core/Chip'
import Avatar from '@material-ui/core/Avatar'
import Typography from '@material-ui/core/Typography'
import grey from '@material-ui/core/colors/grey'

import skills from './skills-data'

import './index.css'

const MainFooter = () => (
  <footer className='MainFooter' style={{ backgroundColor: grey[900] }}>
    <Typography
      color='textPrimary'
      align='center'
      component='h3'
      variant='h3'
      style={{ width: '100%', margin: '2rem auto', color: '#fff' }}
    >
      Habilidades
    </Typography>
    <div className='MainFooter-skills'>
      {skills.map((skill, i) => (
        <Chip
          key={i}
          className='wow bounceIn'
          data-wow-duration='2s'
          style={{ margin: '.5rem' }}
          avatar={<Avatar src={skill.image} alt={`Logo de ${skill.label}`} />}
          color='secondary'
          label={skill.label}
        />
      ))}
    </div>
    <Typography
      align='center'
      variant='h6'
      component='p'
      style={{ color: '#fff', margin: '3rem auto 2rem' }}
    >
      By <a
        href='https://sourcerer.io/orlmonteverde'
        target='_blank'
        rel='noopener noreferrer'
      >
          Orlando Monteverde
      </a>
    </Typography>
  </footer>
)

export default MainFooter
